// extracted by css-extract-rspack-plugin
export default {"column":"_32bfde56","list":"_51a9f762"};